import React from 'react';
import classNames from 'classnames';
import { IS_DEVELOPMENT_BUILD } from '@jwp/ott-common/src/utils/common';
import type { Menu } from 'packages/common/types/config';
import { useTranslation } from 'react-i18next';

import styles from './Footer.module.scss';
import { useTheme } from '../../../../../ThemeContext';
import { useAppInfo } from '@jwp/ott-hooks-react/src/useAppInfo';

type Props = {
  text: string;
  logoSrc: any;
  menu: Menu[];
};

const Footer: React.FC<Props> = ({ text }) => {
  const { t } = useTranslation('common');
  const { universalStyles } = useTheme();
  const { clientSite } = useAppInfo();

  return (
    // The extra style below is just to fix the footer on mobile when the dev selector is shown
    <footer className={classNames(styles.footer, { [styles.testFixMargin]: IS_DEVELOPMENT_BUILD })}>
      {/* {wrapper} */}
      <div className={styles.footerpart2}>
        <hr style={universalStyles.divider} />
        <div className={styles.infoFooter}>
          <span style={universalStyles.footerText}>{text}</span>
          <div className={styles.infoFooterHelpSection}>
            <a href={`https://${clientSite}`} target="_blank" style={{ ...universalStyles.secondaryText, textDecoration: 'underline' }}>
              {clientSite}
            </a>
          </div>
          <div className={styles.poweredByPart}>
            <span style={universalStyles.footerText}>{t('footer.powered_by')}</span>
            <img src="/images/tringappslogo.png" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
